import { apiCardEmSecondAuth } from '@/api';
import main from '@/main';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AppBar from '../../components/appBar';
import Page from '../../components/page';
import { LoadingMask, showToast } from '../../utils/utils';

export default function SecondRealNamePage() {
  const navigate = useNavigate();
  const [cardEmSecondAuth, setCardEmSecondAuth] = useState<CardEmSecondAuth | undefined>();
  useEffect(() => {
    loadPackList();
  }, []); // eslint-disable-line

  async function loadPackList() {
    LoadingMask.show('加载中...');
    try {
      let res = await apiCardEmSecondAuth(main.currentEm?.emNumber!);
      let data = res.data;
      if (data.code === 200) {
        setCardEmSecondAuth(data?.data);
      } else {
        showToast(data.msg ?? '获取认证失败');
      }
    } catch (e: any) {
      showToast(e.message ?? '获取认证失败');
    } finally {
      LoadingMask.hide();
    }
  }

  return (
    <Page
      className="d-flex-c bg-gray"
      contentClassName="flex-1 d-flex-c h-1"
      appBar={
        <AppBar
          title="设备认证"
          onBack={() => {
            navigate(-1);
          }}
        />
      }
    >
      <div className="m-10 p-10 border-radius-8 bg-white d-flex-r ai-center jc-between">
        <div>
          <div className="d-flex-r ai-center mb-10">
            <div className="pl-5 pr-5 pt-3 pb-3 bg-blue-color-t1 border-radius-4 text-blue-color">MAC</div>
            <span className="font-widget-600 ml-10">{cardEmSecondAuth?.emMac}</span>
          </div>
          <div className="d-flex-r ai-center">
            <div className="pl-5 pr-5 pt-3 pb-3 bg-gold-color-t1 border-radius-4 text-orange-color">失效日期</div>
            <span className="font-widget-600 ml-10">{cardEmSecondAuth?.expireTime}</span>
          </div>
        </div>
        {/* <div className="bg-grey-color-t8 text-color-white pt-8 pb-8 pl-20 pr-20 border-radius-8">认证</div> */}
      </div>
      <div className="bw-100 flex-1"></div>
      {/* <div
        className="m-10 mb-40 bg-blue-color-t8 border-radius-30 pt-15 pb-15 text-color-white text-center font-size-16"
        onClick={() => navigate('/certified-equipment')}
      >
        认证新设备
      </div> */}
    </Page>
  );
}
